/**
 * ClickData
 * 
 * Responsible for parsing click platform and identifier from url params.
 */
import { ParsedUrlParams } from './urlparams';

type PlatformConfig = Record<string, Array<string>>;

export interface Result {
    platform: Array<string>;
    id: Array<string>;
}

export default class ClickData {

    static platforms: Record<string, PlatformConfig> = {
        'Google Ads': {
            // gbraid/wbraid are for tracking users who have opted out
            // on iOS 14.x
            'identifier': [
                'gclid',
                'gbraid',
                'wbraid',
                // new tracking click id for display and video inventory
                // see: https://support.google.com/campaignmanager/answer/9182069?hl=en
                'dclid',
            ],
        },
        'Bing Ads': {
            'identifier': [
                'msclkid',
            ],
        },
        'Facebook Ads': {
            'identifier': [
                'fbclid',
                'kcid', // "new" 2021-12 - use for facebook retargeting
            ],
        },
    };

    public static parse(params: ParsedUrlParams) : Result {
        // for each click platform - check the url params against the
        // identifiers
        for (const key in this.platforms) {
            const identifiers = this.platforms[key].identifier;
            for (let i = 0; i < identifiers.length; i++) {
                const identifier = identifiers[i];
                if (typeof(params[identifier]) !== 'undefined') {
                    const id = params[identifier];
                    return {
                        platform: [key],
                        id: [String(id)],
                    };
                }
            }
        }
        // not (paid|display) = empty platform and id
        return {
            platform: [],
            id: [],
        };
    }
}
